import { setOnlineStatus } from '@hooks/useOnlineStatus';

export function setupFetchInterceptor() {
    const originalFetch = window.fetch;

    window.fetch = async (...args) => {
        try {
            const response = await originalFetch(...args);
            setOnlineStatus(true);
            return response;
        } catch (error) {
            setOnlineStatus(false);
            throw error;
        }
    };
}